// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_2VJPU"};